import { Link, Navigate, NavLink, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { useCounters } from "./counters";
import {
  IconBack,
  IconExpenses,
  IconMessages,
  IconParapheur,
  IconSettings,
} from "./components/Icons";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EntityView from "./pages/EntityView";
import DocumentView from "./pages/DocumentView";
import Messages from "./pages/Messages";
import Settings from "./pages/Settings";
import NewDocument from "./pages/NewDocument";
import Admin from "./pages/Admin";
import ChangePassword from "./pages/ChangePassword";
import Expenses from "./pages/Expenses";
import NewExpense from "./pages/NewExpense";
import ExpenseView from "./pages/ExpenseView";

function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const TOP = ["/", "/messages", "/settings", "/expenses"];
  const showBack = !TOP.includes(loc.pathname);
  return (
    <header className="app-header">
      <div className="row">
        {showBack ? (
          <button className="back" onClick={() => nav(-1)} aria-label="Retour">
            <IconBack />
          </button>
        ) : null}
        <Link to="/" className="brand-link" aria-label="Tableau de bord">
          <h1 className="brand">
            <span className="brand-e">e</span>
            <span className="brand-sep">·</span>
            <span className="brand-flux">FLUX</span>
          </h1>
        </Link>
      </div>
      <button className="me" onClick={logout} title="Déconnexion">
        {user?.identifier}
      </button>
    </header>
  );
}

function BottomNav() {
  const { counters } = useCounters();
  return (
    <nav className="bottom-nav" aria-label="Navigation principale">
      <NavLink to="/" end>
        {({ isActive }) => (
          <span className={isActive ? "active" : undefined}>
            <span className="nav-ico"><IconParapheur /></span>
            <span>Parapheur</span>
          </span>
        )}
      </NavLink>
      <NavLink to="/expenses">
        {({ isActive }) => (
          <span className={isActive ? "active" : undefined}>
            <span className="nav-ico pill-wrap">
              <IconExpenses />
              {counters.expenses_to_process > 0 && (
                <span className="pill">{counters.expenses_to_process}</span>
              )}
            </span>
            <span>Notes</span>
          </span>
        )}
      </NavLink>
      <NavLink to="/messages">
        {({ isActive }) => (
          <span className={isActive ? "active" : undefined}>
            <span className="nav-ico pill-wrap">
              <IconMessages />
              {counters.unread_messages > 0 && (
                <span className="pill">{counters.unread_messages}</span>
              )}
            </span>
            <span>Messages</span>
          </span>
        )}
      </NavLink>
      <NavLink to="/settings">
        {({ isActive }) => (
          <span className={isActive ? "active" : undefined}>
            <span className="nav-ico"><IconSettings /></span>
            <span>Réglages</span>
          </span>
        )}
      </NavLink>
    </nav>
  );
}

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="app">
        <div className="app-main"><p className="muted">Chargement…</p></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="app">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  // Premier login après reset : on force le changement de mot de passe.
  if (user.must_change_password) {
    return (
      <div className="app">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="*" element={<ChangePassword />} />
          </Routes>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/entity/:id" element={<EntityView />} />
          <Route path="/documents/new" element={<NewDocument />} />
          <Route path="/documents/:id" element={<DocumentView />} />
          <Route path="/expenses" element={<Expenses />} />
          <Route path="/expenses/new" element={<NewExpense />} />
          <Route path="/expenses/:id" element={<ExpenseView />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/me/password" element={<ChangePassword />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <BottomNav />
    </div>
  );
}
